"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var escodegen_1 = require("escodegen");
var errorTypes_1 = require("./errorTypes");
var splitNodeType = function splitNodeType(nodeType) {
    var tokens = [];
    var soFar = '';
    for (var i = 0; i < nodeType.length; i++) {
        var isUppercase = nodeType[i] === nodeType[i].toUpperCase();
        if (isUppercase && i > 0) {
            tokens.push(soFar);
            soFar = '';
        } else {
            soFar += nodeType[i];
        }
    }
    return tokens;
};
exports.explainError = function (error) {
    switch (error.type) {
        case errorTypes_1.ErrorType.MatchFailure:
            return splitNodeType(error.node.type) + " is not allowed";
        case errorTypes_1.ErrorType.DeclaratorNotIdentifier:
            return 'Declaring a variable using a non-identifier';
        case errorTypes_1.ErrorType.MissingIfAlternate:
            return 'Missing "else" case';
        case errorTypes_1.ErrorType.IfAlternateNotABlockStatement:
            return 'Missing a pair of curly braces around "else"';
        case errorTypes_1.ErrorType.IfConsequentNotABlockStatement:
            return 'Missing a pair ofcurly braces around "if"';
        case errorTypes_1.ErrorType.TrailingComma:
            return 'Trailing comma';
        case errorTypes_1.ErrorType.MissingSemicolon:
            return 'Missing a semicolon at the end of the statement';
        case errorTypes_1.ErrorType.AcornParseError:
            return "Syntax Error: " + error.explanation;
        case errorTypes_1.ErrorType.VariableRedeclaration:
            return "Variable redeclaration: " + error.node.name;
        case errorTypes_1.ErrorType.UseStrictEquality:
            return 'Use (===) instead of (==)';
        case errorTypes_1.ErrorType.UseStrictInequality:
            return 'Use (!==) instead of (!=)';
        case errorTypes_1.ErrorType.UndefinedVariable:
            return "Undefined variable\n" + error.node.name;
        case errorTypes_1.ErrorType.CallingNonFunctionValues:
            return "Trying to call non-function value: " + escodegen_1.generate(error.node);
        default:
            return 'Cannot find any explanation, please report this issue';
    }
};
//# sourceMappingURL=errorUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/errorUtils.js
// module id = 177
// module chunks = 3